module.exports = __webpack_public_path__ + "assets/svg/Icons/32/business-closed-gray-68b4bb.svg";